import { useState, useEffect } from 'react';
import { Save, RefreshCw, Power, Settings2, Plus, Trash2, MessageSquareText } from 'lucide-react';
import { API_URL } from '../../config';




const DEFAULT_ENGINES = [
  { id: 'deepseek', name: 'Deepseek', icon: '/icons/deepseek.png', status: 'active', freq: 'daily', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: true, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'kimi', name: 'Kimi', icon: '/icons/kimi.png', status: 'active', freq: 'daily', prompt: '', multiTurn: true, multiTurnTemplate: '', screenshot: true, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'doubao', name: '豆包(PC)', icon: '/icons/doubao.png', status: 'active', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'doubmb', name: '豆包(MB)', icon: '/icons/doubao.png', status: 'active', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'tongyi', name: '通义千问(PC)', icon: '/icons/tongyi.png', status: 'active', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'qwmb', name: '通义千问(MB)', icon: '/icons/tongyi.png', status: 'disabled', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'wenxin', name: '文心一言', icon: '/icons/wenxin.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'yuanbao', name: '腾讯元宝(PC)', icon: '/icons/yuanbao.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'ybmb', name: '腾讯元宝(MB)', icon: '/icons/yuanbao.png', status: 'disabled', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'baidu_ai', name: '百度AI搜索', icon: '/icons/baidu.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'xiaohongshu', name: '小红书AI', icon: '/icons/xiaohongshu.png', status: 'inactive', freq: 'daily', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'douyin_ai', name: '抖音AI', icon: '/icons/douyin.png', status: 'active', freq: 'daily', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: true, nodesCount: 1, fetchChannel: 'manual' },
];

const DEFAULT_SEO_ENGINES = [
  { id: 'baidu', name: '百度', icon: '/icons/baidu.png', status: 'active', freq: 'daily', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: true, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'xiaohongshu_seo', name: '小红书', icon: '/icons/xiaohongshu.png', status: 'active', freq: 'daily', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: true, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'wechat', name: '微信搜一搜', icon: '/icons/wechat.png', status: 'active', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'douyin', name: '抖音', icon: '/icons/douyin.png', status: 'active', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'zhihu', name: '知乎', icon: '/icons/zhihu.png', status: 'active', freq: 'weekly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'bilibili', name: 'Bilibili', icon: '/icons/bilibili.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'toutiao', name: '今日头条', icon: '/icons/toutiao.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
  { id: 'weibo', name: '微博', icon: '/icons/weibo.png', status: 'inactive', freq: 'monthly', prompt: '', multiTurn: false, multiTurnTemplate: '', screenshot: false, nodesCount: 1, fetchChannel: 'auto' },
];


export default function EngineConfig({ mode }) {
  const ACTIVE_ENGINES = mode === 'seo' ? DEFAULT_SEO_ENGINES : DEFAULT_ENGINES;
  const [activeProjectId, setActiveProjectId] = useState(null);
const [projectEngines, setProjectEngines] = useState({});

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true); // eslint-disable-next-line no-unused-vars
  console.log(loading);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token') || '';
      const sysQuery = mode === 'seo' ? 'seo' : 'geo';
      const res = await fetch(`${API_URL}/brand-projects?system=${sysQuery}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setProjects(data.data);
        if (data.data.length > 0 && !activeProjectId) {
          setActiveProjectId(data.data[0].id);
        }
        
        // build projectEngines map
        
        const newProjectEngines = {};
        data.data.forEach(p => {
          let currentEngines = [];
          if (p.engineConfigs && p.engineConfigs.length > 0) {
            // map from DB but ONLY keep ones that match our ACTIVE_ENGINES list, OR just merge ACTIVE_ENGINES with DB data
            currentEngines = ACTIVE_ENGINES.map(baseEngine => {
               const savedEngine = p.engineConfigs.find(ec => ec.engineId === baseEngine.id);
               if (savedEngine) {
                 return {
                   ...savedEngine,
                   id: savedEngine.engineId,
                   dbId: savedEngine.id,
                   icon: baseEngine.icon
                 };
               }
               return { ...baseEngine };
            });
          } else {
             currentEngines = [...ACTIVE_ENGINES];
          }
          newProjectEngines[p.id] = currentEngines;
        });
        setProjectEngines(newProjectEngines);

      }
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);


  
  // Fetch System Personas
  
  const handleSaveConfig = async () => {
    try {
      const token = localStorage.getItem('token') || '';
      const currentEngines = projectEngines[activeProjectId];
      if (!currentEngines) return;

      for (const engine of currentEngines) {
        if (engine.dbId) {
           await fetch(`${API_URL}/brand-projects/engines/${engine.dbId}`, {
             method: 'PUT',
             headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
             },
             body: JSON.stringify({
               status: engine.status,
               frequency: engine.frequency,
               prompt: engine.prompt,
               multiTurn: engine.multiTurn,
               multiTurnTemplate: engine.multiTurnTemplate,
               fetchChannel: engine.fetchChannel,
               screenshot: engine.screenshot,
               nodesCount: engine.nodesCount
             })
           });
        } else {
           await fetch(`${API_URL}/brand-projects/${activeProjectId}/engines`, {
             method: 'POST',
             headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
             },
             body: JSON.stringify({
               engineId: engine.id,
               name: engine.name,
               status: engine.status,
               frequency: engine.frequency || engine.freq,
               prompt: engine.prompt,
               multiTurn: engine.multiTurn,
               multiTurnTemplate: engine.multiTurnTemplate,
               fetchChannel: engine.fetchChannel,
               screenshot: engine.screenshot,
               nodesCount: engine.nodesCount
             })
           });
        }
      }
      alert('保存成功！');
      fetchProjects();
    } catch(err) {
      console.error(err);
      alert('保存失败');
    }
  };

  const [systemPersonas, setSystemPersonas] = useState([]);
  
  useEffect(() => {
    const fetchSystemPersonas = async () => {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/personas/system`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setSystemPersonas(data);
        }
      } catch (err) {
        console.error('Failed to fetch system personas:', err);
      }
    };
    fetchSystemPersonas();
  }, []);

  // Custom personas for current project (Mock for now until Brand API is ready)
  
  const [projectPersonas, setProjectPersonas] = useState([]);
  
  useEffect(() => {
    if (activeProjectId && projects.length > 0) {
      const activeProj = projects.find(p => p.id === activeProjectId);
      if (activeProj && activeProj.personas) {
        setProjectPersonas(activeProj.personas);
      } else {
        setProjectPersonas([]);
      }
    }
  }, [activeProjectId, projects]);


  const allAvailablePersonas = [...systemPersonas, ...projectPersonas];

  const [activePersonaIds, setActivePersonaIds] = useState([]);

  useEffect(() => {
    if (activeProjectId && projects.length > 0) {
      const activeProj = projects.find(p => p.id === activeProjectId);
      if (activeProj && activeProj.activePersonaIds) {
        const ids = activeProj.activePersonaIds.split(',').map(id => parseInt(id)).filter(id => !isNaN(id));
        setActivePersonaIds(ids);
      } else {
        // 如果项目没有配置过人设，就不默认勾选任何项，或者给个空数组
        setActivePersonaIds([]);
      }
    }
  }, [activeProjectId, projects]);

  const togglePersona = async (id) => {
    let newIds = [];
    if (activePersonaIds.includes(id)) {
      newIds = activePersonaIds.filter(pid => pid !== id);
      setActivePersonaIds(newIds);
    } else {
      newIds = [...activePersonaIds, id];
      setActivePersonaIds(newIds);
    }
    
    // Update local projects array so it doesn't revert on project switch
    const newIdsStr = newIds.join(',');
    setProjects(projects.map(p => p.id === activeProjectId ? { ...p, activePersonaIds: newIdsStr } : p));
    
    // Auto-save activePersonaIds to backend
    if (activeProjectId) {
      try {
        const token = localStorage.getItem('token') || '';
        await fetch(`${API_URL}/brand-projects/${activeProjectId}/active-personas`, {
             method: 'PUT',
             headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
             },
             body: JSON.stringify({ activePersonaIds: newIds.join(',') })
        });
      } catch (err) {
        console.error('Failed to save active personas:', err);
      }
    }
  };

  const engines = projectEngines[activeProjectId] || [];
  /* eslint-disable-next-line no-unused-vars */
  const activeProject = projects.find(p => p.id === activeProjectId);

  const updateEngine = async (id, field, value) => {
    const updated = engines.map(e => e.id === id ? { ...e, [field]: value } : e);
    setProjectEngines({ ...projectEngines, [activeProjectId]: updated });

    // Auto-save the specific field
    const engine = updated.find(e => e.id === id); // Use 'updated' so it saves the new value!
    if (engine) {
      try {
        const token = localStorage.getItem('token') || '';
        if (engine.dbId) {
          await fetch(`${API_URL}/brand-projects/engines/${engine.dbId}`, {
               method: 'PUT',
               headers: {
                 'Authorization': `Bearer ${token}`,
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify({ [field]: value })
          });
        } else {
          const res = await fetch(`${API_URL}/brand-projects/${activeProjectId}/engines`, {
               method: 'POST',
               headers: {
                 'Authorization': `Bearer ${token}`,
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify({
                 engineId: engine.id,
                 name: engine.name,
                 status: engine.status,
                 frequency: engine.frequency || engine.freq,
                 prompt: engine.prompt,
                 multiTurn: engine.multiTurn,
                 multiTurnTemplate: engine.multiTurnTemplate,
                 fetchChannel: engine.fetchChannel,
                 screenshot: engine.screenshot,
                 nodesCount: engine.nodesCount
               })
          });
          const data = await res.json();
          if (data.success && data.data) {
             const finalUpdated = updated.map(e => e.id === id ? { ...e, dbId: data.data.id } : e);
             setProjectEngines(prev => ({ ...prev, [activeProjectId]: finalUpdated }));
          }
        }
      } catch (err) {
        console.error('Failed to auto-save engine config:', err);
      }
    }
  };

  const toggleStatus = (id) => {
    const engine = engines.find(e => e.id === id);
    const newStatus = engine.status === 'active' ? 'inactive' : 'active';
    updateEngine(id, 'status', newStatus);
  };

  return (
    <div className="space-y-6 max-w-full p-2 pb-12">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">{mode === 'seo' ? '平台与抓取配置' : '引擎与抓取配置'}</h1>
          <p className="text-sm text-gray-500 mt-1">{mode === 'seo' ? '按项目粒度配置各大社媒平台与搜索引擎的抓取策略' : '按项目粒度配置 AI 引擎开关、抓取通道与专属对话策略'}</p>
        </div>
        <button onClick={handleSaveConfig} className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors shadow-sm">
          <Save size={16} />
          <span>保存所有项目配置</span>
        </button>
      </div>

      {/* Project Selector */}
      <div className="flex items-center space-x-4 mb-6 bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700">
        <label className="text-sm font-semibold text-gray-700 dark:text-slate-300 whitespace-nowrap">
          当前配置项目：
        </label>
        <div className="relative flex-1 max-w-sm">
          <select
            value={activeProjectId || ''}
            onChange={(e) => setActiveProjectId(parseInt(e.target.value))}
            className="w-full appearance-none bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-600 text-gray-900 dark:text-slate-100 text-sm font-medium rounded-lg focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 block pl-4 pr-10 py-2.5 transition-colors cursor-pointer outline-none"
          >
            {projects.length === 0 ? (
              <option value="">暂无项目</option>
            ) : (
              projects.map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))
            )}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>

      {/* Engine List */}
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 overflow-hidden">
        <div className="p-5 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100 flex items-center">
            <Settings2 size={18} className="mr-2 text-indigo-500" />
            目标引擎精细化配置
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-gray-50/80 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700/50">
              <tr className="text-gray-500 dark:text-slate-400">
                <th className="px-5 py-4 font-medium w-48">AI 引擎</th>
                <th className="px-5 py-4 font-medium w-24">状态</th>
                <th className="px-5 py-4 font-medium">{mode === 'seo' ? '抓取参数 / 高级设置' : '独立 Prompt / 高级设置'}</th>
                <th className="px-5 py-4 font-medium w-32 text-right">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50 dark:divide-slate-700/50">
              {engines.map((engine) => (
                <tr key={engine.id} className={`transition-colors ${engine.id === 'baidu_ai' ? 'opacity-40 bg-gray-100/50 dark:bg-slate-800/10 grayscale' : engine.status === 'active' ? 'hover:bg-gray-50 dark:hover:bg-slate-800/50' : 'opacity-60 bg-gray-50/50 dark:bg-slate-800/20'}`}>
                  <td className="px-5 py-4 align-top">
                    <div className="flex items-center mt-1">
                      <img src={engine.icon} alt={engine.name} className="w-6 h-6 mr-3 rounded shadow-sm object-cover bg-white p-0.5" />
                      <span className="font-semibold text-gray-900 dark:text-slate-200">{engine.name}</span>
                    </div>
                  </td>
                  <td className="px-5 py-4 align-top pt-5">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      engine.id === 'baidu_ai'
                        ? 'bg-orange-100 text-orange-800 dark:bg-orange-500/20 dark:text-orange-300'
                        : engine.status === 'active' 
                        ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-300' 
                        : 'bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-slate-300'
                    }`}>
                      {engine.id === 'baidu_ai' ? '待开放' : engine.status === 'active' ? '监控中' : '未开启'}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <details className="group">
                      <summary className={`text-sm font-medium cursor-pointer list-none flex items-center transition-colors ${engine.status !== 'active' ? 'text-gray-400 dark:text-slate-500 pointer-events-none' : 'text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300'}`}>
                        <svg className="w-4 h-4 mr-1.5 transition-transform group-open:rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                        <span className="group-open:hidden">{mode === 'seo' ? '高级设置 (抓取通道/截屏/并发)' : '高级设置 (独立Prompt/截屏/并发)'}</span>
                        <span className="hidden group-open:inline">收起高级设置</span>
                        {/* 如果已经配置了内容，给个小红点或高亮提示 */}
                        {(mode !== 'seo' && (engine.prompt || engine.multiTurn)) && !engine.status !== 'active' && (
                          <span className="ml-2 flex w-2 h-2 rounded-full bg-orange-500 group-open:hidden"></span>
                        )}
                      </summary>
                      
                      <div className="space-y-3 mt-4 pl-1">
                        {mode !== 'seo' && (
                          <>
                            <div>
                              <label className="block text-xs text-gray-500 dark:text-slate-400 mb-1.5">独立 Prompt (可选)</label>
                              <input 
                                type="text"
                                value={engine.prompt}
                                onChange={(e) => updateEngine(engine.id, 'prompt', e.target.value)}
                                disabled={engine.status !== 'active'}
                                placeholder="覆盖全局 Prompt (留空则使用全局配置)"
                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 dark:bg-slate-800 dark:border-slate-600 dark:text-white disabled:opacity-50 outline-none"
                              />
                            </div>
                            <div className="pt-2 border-t border-gray-100 dark:border-slate-700/50">
                              <label className={`flex items-center text-sm ${engine.status !== 'active' ? 'opacity-50' : ''}`}>
                                <input 
                                  type="checkbox" 
                                  checked={engine.multiTurn}
                                  onChange={(e) => updateEngine(engine.id, 'multiTurn', e.target.checked)}
                                  disabled={engine.status !== 'active'}
                                  className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 dark:bg-slate-700 dark:border-slate-600"
                                />
                                <span className="ml-2 text-gray-700 dark:text-slate-300">开启多轮追问 (未提及品牌时自动追问)</span>
                              </label>
                              {engine.multiTurn && (
                                <div className="pl-6 mt-2.5 mb-2">
                                  <input 
                                    type="text"
                                    value={engine.multiTurnTemplate || ''}
                                    onChange={(e) => updateEngine(engine.id, 'multiTurnTemplate', e.target.value)}
                                    disabled={engine.status !== 'active'}
                                    placeholder="自定义追问模板 (例如: 那你觉得 {brand_name} 怎么样？)"
                                    className="w-full bg-indigo-50/50 border border-indigo-100 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 dark:bg-indigo-900/10 dark:border-indigo-800/30 dark:text-white disabled:opacity-50 outline-none placeholder:text-gray-400 dark:placeholder:text-slate-500"
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        )}


                        {/* Screenshots & Multi-node Sampling & Fetch Channel */}
                        <div className="pt-2 border-t border-gray-100 dark:border-slate-700/50 flex flex-col space-y-3">
                          <div className={`flex items-center justify-between pl-1 text-sm ${engine.status !== 'active' ? 'opacity-50' : ''}`}>
                            <span className="text-gray-600 dark:text-slate-400">抓取通道：</span>
                            <select
                              value={engine.fetchChannel || 'auto'}
                              onChange={(e) => updateEngine(engine.id, 'fetchChannel', e.target.value)}
                              disabled={engine.status !== 'active'}
                              className="bg-gray-50 border border-gray-200 text-gray-900 text-xs rounded focus:ring-indigo-500 focus:border-indigo-500 block p-1.5 dark:bg-slate-800 dark:border-slate-600 dark:text-white disabled:opacity-50 outline-none w-48"
                            >
                              {mode === 'seo' ? (
                                <option value="mingxi">明悉 RPA 集群 (支持截屏)</option>
                              ) : (
                                <>
                                  <option value="auto">智能路由 (自动选择)</option>
                                  <option value="api">官方直连 API (无截屏)</option>
                                  <option value="mingxi">明悉集群 (支持截屏/多机位)</option>
                                </>
                              )}
                            </select>
                          </div>
                          <div className="flex items-center justify-between">
                            <label className={`flex items-center text-sm ${engine.status !== 'active' ? 'opacity-50' : ''} ${engine.fetchChannel === 'api' ? 'opacity-40 cursor-not-allowed' : ''}`}>
                              <input 
                                type="checkbox" 
                                checked={engine.screenshot !== false}
                                onChange={(e) => updateEngine(engine.id, 'screenshot', e.target.checked)}
                                disabled={engine.status !== 'active' || engine.fetchChannel === 'api'}
                                className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 dark:bg-slate-700 dark:border-slate-600"
                              />
                              <span className="ml-2 text-gray-700 dark:text-slate-300">回答截屏留证 (供人工复核)</span>
                            </label>
                          </div>
                          
                          <div className={`flex items-center justify-between pl-6 text-sm ${engine.status !== 'active' ? 'opacity-50' : ''} ${engine.fetchChannel === 'api' ? 'opacity-40 cursor-not-allowed' : ''}`}>
                            <span className="text-gray-600 dark:text-slate-400">多机位采样结果数 (并发数)：</span>
                            <select
                              value={engine.nodesCount || 1}
                              onChange={(e) => updateEngine(engine.id, 'nodesCount', parseInt(e.target.value))}
                              disabled={engine.status !== 'active' || engine.fetchChannel === 'api'}
                              className="bg-gray-50 border border-gray-200 text-gray-900 text-xs rounded focus:ring-indigo-500 focus:border-indigo-500 block p-1.5 dark:bg-slate-800 dark:border-slate-600 dark:text-white disabled:opacity-50 outline-none w-20"
                            >
                              <option value={1}>1 台</option>
                              <option value={3}>3 台</option>
                              <option value={5}>5 台</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </details>
                  </td>
                  <td className="px-5 py-4 align-top text-right">
                    {engine.id === 'baidu_ai' ? (
                      <button 
                        disabled
                        className="text-xs px-3 py-1.5 rounded-md border border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed dark:border-slate-700 dark:bg-slate-800 dark:text-slate-500"
                      >
                        暂未开放
                      </button>
                    ) : (
                      <button 
                        onClick={() => toggleStatus(engine.id)}
                        className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${
                          engine.status === 'active' 
                            ? 'border-red-200 text-red-600 bg-red-50 hover:bg-red-100 dark:border-red-900/50 dark:text-red-400 dark:bg-red-900/20' 
                            : 'border-emerald-200 text-emerald-600 bg-emerald-50 hover:bg-emerald-100 dark:border-emerald-900/50 dark:text-emerald-400 dark:bg-emerald-900/20'
                        }`}
                      >
                        {engine.status === 'active' ? '停用此引擎' : '启用此引擎'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      {/* Persona Library Injection */}
      
      {mode !== 'seo' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 overflow-hidden mb-6">
        <div className="p-5 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20 flex justify-between items-center">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100 flex items-center">
              <MessageSquareText size={18} className="mr-2 text-indigo-500" />
              启用受众人设 (Persona Injection)
            </h2>
            <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">
              勾选需要在此次抓取任务中启用的用户人设。系统将自动执行：<span className="font-semibold text-indigo-600 dark:text-indigo-400">词库总量 × 人设数量 × 引擎数量</span> 的乘法矩阵抓取。
            </p>
          </div>
        </div>
        <div className="p-5">
          {(!allAvailablePersonas || allAvailablePersonas.length === 0) ? (
            <div className="text-center py-6 text-gray-500 dark:text-slate-400 text-sm bg-gray-50 dark:bg-slate-900/30 rounded-xl border border-dashed border-gray-200 dark:border-slate-700">
              当前系统无可用人设。请前往「系统设置」中添加全局受众人设。
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {allAvailablePersonas.map(persona => (
                <div key={persona.id} className="relative flex items-start p-4 border rounded-xl hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800">
                  <div className="min-w-0 flex-1 flex items-center gap-3">
                    <input
                      id={`persona-${persona.id}`}
                      type="checkbox"
                      checked={activePersonaIds.includes(persona.id)}
                      onChange={() => togglePersona(persona.id)}
                      className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 cursor-pointer"
                    />
                    <label htmlFor={`persona-${persona.id}`} className="cursor-pointer select-none">
                      <div className="font-medium text-sm text-gray-900 dark:text-white flex items-center gap-2">
                        {persona.name}
                        {activePersonaIds.includes(persona.id) ? 
                          <span className="px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 text-[10px] font-bold tracking-wider">ON</span> :
                          <span className="px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 text-[10px] font-bold tracking-wider">OFF</span>
                        }
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-2" title={persona.description || persona.prompt}>
                        {persona.description || persona.prompt || '全局系统预设人群'}
                      </div>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      )}


      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50 rounded-xl p-4 flex items-start mt-6">
        <div className="text-blue-500 dark:text-blue-400 mt-0.5 mr-3">
          <RefreshCw size={20} />
        </div>
        <div>
          <h4 className="text-sm font-semibold text-blue-800 dark:text-blue-300">
            {mode === 'seo' ? 'SEO 平台抓取建议' : 'GEO 抓取调度建议'}
          </h4>
          <p className="text-sm text-blue-700/80 dark:text-blue-300/80 mt-1">
            {mode === 'seo' ? (
              <>
                平台抓取通过 RPA 物理机房阵列执行，受制于各大平台严苛的反爬风控策略，每次抓取均需消耗独立的纯净住宅 IP 与高匿设备指纹。请合理设置监控并发数，避免资源浪费与风控熔断。
              </>
            ) : (
              <>
                为保证数据客观性，系统每次抓取会使用不同的随机指纹和 IP 代理。若开启“多轮追问”，会额外消耗 Token 成本及时间，建议仅针对核心竞品分析时开启。
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
